import React, { useState } from "react";
import { Button } from "react-bootstrap";
import ProductsLearnMoreModal from "./ProductsLearnMoreModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";

export default function ProductsWeatherMonitoringAndAlerting() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleLearnMoreClick = (event, product) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedProduct(product);
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
  };

  return (
    <div className="bg-page rounded-4 p-3 mb-5">
      <div className="text-center mb-4">
        <img
          src="/assets/products/images/weather.png"
          alt="Weather Monitoring and Alerting"
          className="img-fluid rounded-4"
          style={{ maxHeight: "280px", objectFit: "cover" }}
        />
        <div className="fw-bold text-navy text-center fs-2 mt-3">
          Weather Monitoring and Alerting
        </div>
      </div>

      <div>
        <p className="fs-5 mt-3">
          Monitoring weather conditions and communicating their impact is both a
          corporate responsibility and a duty of care.
        </p>
        <p className="fs-5 ">
          Disruption caused by adverse weather needs to be anticipated, managed,
          and communicated clearly to protect people and maintain operational
          continuity.
        </p>
        <p className="fs-5 ">
          Boomerang’s Weather Monitor gives organisations full control over how
          this is handled. Customers define the parameters, set the thresholds,
          and design the process for warning, escalation and stakeholder
          communication.
        </p>
        <p className="fs-5 ">
          The platform continuously monitors weather conditions in real time and
          triggers actions based on rules you define, including weather type,
          severity, geographic impact, and the specific audiences affected.
          Notifications can be tailored by channel and urgency, ensuring the
          right message reaches the right people at the right time.
        </p>
        <p className="fs-5 ">
          Workflows can automatically escalate as conditions change, with
          integration into boomLogic’s asset management capabilities that link
          weather events directly to physical locations, infrastructure, and
          operational risk.
        </p>
        <p className="fs-5 ">
          Once configured, the process runs autonomously, reducing manual
          intervention while maintaining full visibility and control. A
          mapping-based interface allows teams to monitor conditions, track
          impact, and intervene where needed through a single, intuitive view.
        </p>
        <p className="fs-5 ">
          Weather intelligence within Boomerang can also be combined with:
        </p>
        <p>
          <div className="align-items-center gap-2">
            <a
              href="/workflows/products/monitoringAndAlerting"
              className="text-decoration-none text-navy"
            >
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Monitoring</span>
            </a>
          </div>

          <div className="align-items-center gap-2">
            <a
              href="/workflows/products/eventsAndAlerting"
              className="text-decoration-none text-navy"
            >
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Events and Alerting</span>
            </a>
          </div>
          <div className="align-items-center gap-2">
            <a
              href="/workflows/products/solutions"
              className="text-decoration-none text-navy"
            >
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Solutions</span>
            </a>
          </div>
        </p>
      </div>

      <div className="text-center d-flex justify-content-center gap-3 mt-4">
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "trial" })}
        >
          Free trial
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "buy" })}
        >
          Buy
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) =>
            handleLearnMoreClick(event, { name: "more information" })
          }
        >
          More Information
        </Button>
        <ProductsLearnMoreModal
          selectedProduct={selectedProduct}
          handleCloseModal={handleCloseModal}
        />
      </div>
    </div>
  );
}
